export default __webpack_public_path__ + "86466c344d7f79d69e7449fc73fcd3e2.png";